/**
 * Creates a new RadioactiveMaterialsTestAlertsController.
 * @class
 */
import { SystemAlertsController } from '../../../system/alerts/system-alerts.component';

class RadioactiveMaterialsTestAlertsController extends SystemAlertsController {
    /* @ngInject */
    constructor($ngRedux, $state, NavigationService) {
        super($ngRedux, $state, NavigationService);
        this.config = {
            filter: './rm-test-alerts-grid-filter.html',
            columns: [
                {title: '#',                    mapper: null},
                {title: '',                     mapper: 'alert'},
                {title: 'Location',             mapper: 'location'},
                {title: 'Asset/Order ID',       mapper: 'sourceId'},
                {title: 'Source Type',          mapper: 'sourceType'},
                {title: 'Serial No.',           mapper: 'serialNumber'},
                {title: 'License No.',          mapper: 'licenseNumber'},
                {title: 'Isotope',              mapper: 'isotope'},
                {title: 'Initial Activity',     mapper: 'initialActivity'},
                {title: 'Current Activity',     mapper: 'currentActivity'},
                {title: 'Service Due Date',     mapper: 'serviceDueDate'},
                {title: 'Leak Test Due Date',   mapper: 'leakTestDueDate'},
            ]
        };
    }

    $onInit() {
        const navConfig = this.NavigationService.getConfig(this.$state.$current);
        this.colorName = navConfig.colorName;
        this.icon = navConfig.icon;
        this.rmTestAlertsModuleID = 342;
    }

    onSelect(event) {
        // this.$state.go(this.state, {id: event.item.equipmentId});
    }
}

export const rmTestAlerts = {
    bindings: {
        state: '@'
    },
    controller: RadioactiveMaterialsTestAlertsController,
    template: `
        <system-alerts-grid identifier="rmTestAlertsGrid"
                           module-id="$ctrl.rmTestAlertsModuleID"
                           icon="alerts.svg"
                           config="$ctrl.config"
                           on-select="$ctrl.onSelect($event)">
        </system-alerts-grid>
    `
};
